import CheckoutPanel from 'checkout/components/CheckoutPanel'
import { CheckoutQA } from 'shared/dataAttributes'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { PromotionForm } from 'checkout/panels/Promotion/PromotionForm'
import { PromotionSummary } from 'checkout/panels/Promotion/PromotionSummary'
import { t } from 'localization'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { useUser } from 'shared/hooks/useUser'

const TP = 'checkout.panels.Promotion.PromotionPanel'

export const PromotionPanel = () => {
  const guestPromosEnabled = useFeatureFlag(FeatureFlag.PROMO_CODES_GUEST)
  const userPromosEnabled = useFeatureFlag(FeatureFlag.PROMO_CODES_USER)
  const { currentUser } = useUser()

  const isPromoCodeEnabled = (() => {
    if (!currentUser) {
      return false
    }
    if (currentUser.isGuest) {
      return guestPromosEnabled
    }
    return userPromosEnabled
  })()

  if (!isPromoCodeEnabled) {
    return null
  }

  return (
    <CheckoutPanel
      editable={false}
      expandedContent={<PromotionForm />}
      hideIndicator
      name="promotion"
      qaAttr={CheckoutQA.Promotion}
      summarizedContent={<PromotionSummary />}
      title={t(`${TP}.title`, 'Promo Code')}
    />
  )
}
